import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-section col" }
const _hoisted_2 = { class: "container no-padding" }
const _hoisted_3 = { class: "row content-card-full" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 blog-post-container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "blog-date" }, "3 augusti 2020", -1)
const _hoisted_9 = { class: "header-content-sm" }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          style: {"width":"100%"},
          class: "card-image-corners",
          src: '/api/media/' + _ctx.post.featuredImageID + '/test'
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.post.title), 1),
              _createElementVNode("div", {
                class: "blog-post-text",
                innerHTML: _ctx.post.content
              }, null, 8, _hoisted_10)
            ])
          ])
        ])
      ])
    ])
  ]))
}